<template>
    <b-modal
        size="lg mismatcherrors"
        title="Mismatch Rows"
        ref="MismatchRows"
        @hidden="closeModal"
        centered
        scrollable>
        <div class="modal-form text-center py-4">
            <p>You have an invalid field entry within the tsv file.</p>
            <template v-if="groupFieldErrors.length > 0">
                <div class="mb-3">
                    <p>Please check the line(s) for the ff. errors:</p>
                    <b-row
                        no-gutters
                        v-for="(field, index) in groupFieldErrors"
                        :key="index"
                        class="w-100 justify-content-start">
                        <b-col sm="12"
                            v-for="(row, index) in field"
                            :key="index[index + 1]"
                            class="text-left">
                            <p class="text-primary mt-3 mb-2">Line {{ row.line }}</p>
                            <template v-if="row.message.asset_id">
                                <p>{{ row.message.asset_id[0] }}</p>
                                <p>{{ row.message.asset_id[1] }}</p>
                            </template>
                            <template v-if="row.message.asset_number">
                                <p>{{ row.message.asset_number[0] }}</p>
                                <p>{{ row.message.asset_number[1] }}</p>
                            </template>
                            <template v-if="row.message.barcode">
                                <p>{{ row.message.barcode[0] }}</p>
                                <p>{{ row.message.barcode[1] }}</p>
                            </template>
                            <template v-if="row.message.barcode_number">
                                <p>{{ row.message.barcode_number[0] }}</p>
                                <p>{{ row.message.barcode_number[1] }}</p>
                            </template>
                            <template v-if="row.message.cabinet_model_code">
                                <p>{{ row.message.cabinet_model_code[0] }}</p>
                                <p>{{ row.message.cabinet_model_code[1] }}</p>
                            </template>
                            <template v-if="row.message.cabinet_model_description">
                                <p>{{ row.message.cabinet_model_description[0] }}</p>
                                <p>{{ row.message.cabinet_model_description[1] }}</p>
                            </template>
                            <template v-if="row.message.cabinet_size">
                                <p>{{ row.message.cabinet_size[0] }}</p>
                                <p>{{ row.message.cabinet_size[1] }}</p>
                            </template>
                            <template v-if="row.message.cabinet_size_num">
                                <p>{{ row.message.cabinet_size_num[0] }}</p>
                                <p>{{ row.message.cabinet_size_num[1] }}</p>
                            </template>
                            <template v-if="row.message.cabinet_subtype_code">
                                <p>{{ row.message.cabinet_subtype_code[0] }}</p>
                                <p>{{ row.message.cabinet_subtype_code[1] }}</p>
                            </template>
                            <template v-if="row.message.cabinet_subtype_description">
                                <p>{{ row.message.cabinet_subtype_description[0] }}</p>
                            </template>
                            <template v-if="row.message.count">
                                <p>{{ row.message.count[0] }}</p>
                            </template>
                            <template v-if="row.message.country_code">
                                <p>{{ row.message.country_code[0] }}</p>
                            </template>
                            <template v-if="row.message.country_name">
                                <p>{{ row.message.country_name[0] }}</p>
                            </template>
                            <template v-if="row.message.dt_code">
                                <p>{{ row.message.dt_code[0] }}</p>
                            </template>
                            <template v-if="row.message.dt_name">
                                <p>{{ row.message.dt_name[0] }}</p>
                            </template>
                            <template v-if="row.message.movement_date">
                                <p>{{ row.message.movement_date[0] }}</p>
                            </template>
                            <template v-if="row.message.ngdms_cabinet_brand">
                                <p>{{ row.message.ngdms_cabinet_brand[0] }}</p>
                            </template>
                            <template v-if="row.message.ngdms_cabinet_brand_type">
                                <p>{{ row.message.ngdms_cabinet_brand_type[0] }}</p>
                            </template>
                            <template v-if="row.message.outlet_code">
                                <p>{{ row.message.outlet_code[0] }}</p>
                                <p>{{ row.message.outlet_code[1] }}</p>
                            </template>
                            <template v-if="row.message.outlet_name">
                                <p>{{ row.message.outlet_name[0] }}</p>
                            </template>
                            <template v-if="row.message.route_id">
                                <p>{{ row.message.route_id[0] }}</p>
                                <p>{{ row.message.route_id[1] }}</p>
                            </template>
                            <template v-if="row.message.salesman_code">
                                <p>{{ row.message.salesman_code[0] }}</p>
                            </template>
                            <template v-if="row.message.salesman_name">
                                <p>{{ row.message.salesman_name[0] }}</p>
                            </template>
                            <template v-if="row.message.serial_number">
                                <p>{{ row.message.serial_number[0] }}</p>
                            </template>
                            <template v-if="row.message.site_code">
                                <p>{{ row.message.site_code[0] }}</p>
                                <p>{{ row.message.site_code[1] }}</p>
                            </template>
                            <template v-if="row.message.site_name">
                                <p>{{ row.message.site_name[0] }}</p>
                            </template>
                        </b-col>
                    </b-row>
                </div>
            </template>
            <template v-if="groupMismatchCol.length > 0">
                <p>Please check the line(s) mismatch columns:</p>
                <b-row
                    no-gutters
                    v-for="(col, index) in groupMismatchCol"
                    :key="index"
                    class="w-100 justify-content-start">
                    <b-col sm="4"
                        offset="2"
                        v-for="(row, index) in col"
                        :key="index[index  + 1]"
                        class="text-left">
                        Line {{ row }}
                    </b-col>
                </b-row>
            </template>
        </div>
        <div slot="modal-footer" class="pt-4">
            <b-button
                variant="primary"
                style="margin-left: .25rem;"
                @click="closeModal">
                OK
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";
import notification from "../../../services/notification";

export default {
    name: "MismatchRows",
    props: ["open"],
    data() {
        return {
            nColumns: 2,
            groupFieldErrors: [],
            groupMismatchCol: []
        };
    },
    computed: {
        ...mapState("reportsAsset", ["data_errors"])
    },
    methods: {
        closeModal: async function() {
            await this.$store.commit("reportsAsset/setMismatchRows", null);
        },
        chunk: function(arr, size) {
            var newFieldErrors = [];
            var newMismatchCol = [];
            if (arr.field_errors.length > 0) {
                for (var i=0; i<arr.field_errors.length; i+=size) {
                    newFieldErrors.push(arr.field_errors.slice(i, i+size));
                    this.groupFieldErrors  = newFieldErrors;
                }
            } else {
                this.groupFieldErrors = [];
            }
            if (arr.mismatch_col.length > 0) {
                for (var i=0; i<arr.mismatch_col.length; i+=size) {
                    newMismatchCol.push(arr.mismatch_col.slice(i, i+size));
                    this.groupMismatchCol  = newMismatchCol;
                }
            } else {
                this.groupMismatchCol = [];
            }
        }
    },
    watch: {
        open: function(value) {
            if(value === true) {
                this.$refs.MismatchRows.show();

                var _self = this;
                _self.chunk(this.data_errors, this.nColumns);
            } else {
                this.$refs.MismatchRows.hide();
            }
        }
    }
}
</script>
